import { useState } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { LocationSelectionStep } from '../../components/onboarding-flow-components/location-selection-step';
import { StackedCardWizardStep } from '../../components/onboarding-flow-components/stacked-card-wizard/stacked-card-wizard-step-compound';
import { useStepData } from '../../components/onboarding-flow-components/stacked-card-wizard/use-step-data';
import { useOnboardingFlowInfo } from '../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';
import { trackOnboardingFlow } from '../../utils/track-onboarding-flow';
import { OnboardingStep, LocationStepData } from './types';

// TODO: Use selected calendar locations - store can't be accessed outside - can send location IDs in route context

export const LocationStep = () => {
  const { t } = useTranslation('schedule-onboarding');
  const { selectedLocationIds, getLocationName } = useSchedulingLocationInfo();
  const { context } = useSettingsNavigate<{ calendarLocationIds?: string[] }>();
  const locationOptions = context?.calendarLocationIds?.length
    ? context.calendarLocationIds.map((id) => ({ id, name: getLocationName(id) }))
    : selectedLocationIds.map((id) => ({ id, name: getLocationName(id) }));

  const { onboardingFlowInfo, setOnboardingFlowInfo } = useOnboardingFlowInfo();
  const { mergeData, getData } = useStepData<LocationStepData>(OnboardingStep.Location);
  const stepData = getData();

  const [selectedId, setSelectedId] = useState(onboardingFlowInfo.locationId || stepData.locationId);

  const onNextClick = () => {
    mergeData({ locationId: selectedId });

    // Set user preference
    if (selectedId !== onboardingFlowInfo.locationId) {
      setOnboardingFlowInfo({
        locationId: selectedId,
      });
    }
    trackOnboardingFlow('wizardLocationStepCompleted');
  };

  return (
    <StackedCardWizardStep stepId={OnboardingStep.Location} canGoNext={!!selectedId} onNext={onNextClick}>
      <StackedCardWizardStep.Header
        title={t('Which location should we start with?')}
        description={t("You'll be able to configure the rest later")}
      />

      <StackedCardWizardStep.Content>
        <LocationSelectionStep
          selectedId={selectedId}
          options={locationOptions}
          onSelect={(value) => setSelectedId(value)}
        />
      </StackedCardWizardStep.Content>

      <StackedCardWizardStep.Footer />
    </StackedCardWizardStep>
  );
};
